import { AlertTriangle, CheckCircle2, Clock, User } from "lucide-react";

const RemediationTab = ({ remediationData }) => {

    return (<>
        <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
             <div>
                <h3 className="text-2xl font-bold text-slate-900 tracking-tight">Remediation Action Plan</h3>
                <p className="text-sm text-slate-500 mt-1">Assigned tasks to resolve identified compliance gaps.</p>
              </div>
            <div className="grid grid-cols-1 gap-4">
              {remediationData.map((rem) => (
                <div key={rem.id} className="bg-white ring-1 ring-slate-200/60 rounded-2xl shadow-sm p-5 hover:ring-indigo-300 transition-all group">
                  <div className="flex flex-col md:flex-row items-start md:items-center gap-5">
                    
                    <div className="flex items-start gap-4 flex-1 w-full">
                      <div className={`p-3 shrink-0 rounded-xl ring-1 mt-1 md:mt-0 ${rem.status === 'Completed' ? 'bg-emerald-50 text-emerald-600 ring-emerald-200' : 'bg-amber-50 text-amber-600 ring-amber-200'}`}>
                        {rem.status === 'Completed' ? <CheckCircle2 size={24} /> : <Clock size={24} />}
                      </div>
                      
                      <div className="flex-1 space-y-2">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-2 py-0.5 rounded-md tracking-widest">{rem.id}</span>
                          <span className="text-[10px] font-bold text-rose-700 bg-rose-50 ring-1 ring-rose-200/50 px-2.5 py-0.5 rounded-md flex items-center gap-1"><AlertTriangle size={12} /> Resolves {rem.gapId}</span>
                        </div>
                        <h4 className="text-base font-bold text-slate-900">{rem.action}</h4>
                        <div className="flex flex-wrap items-center gap-3 pt-1">
                          <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-100"><Clock size={14} className="text-slate-400" /> Due: {rem.due}</span>
                          <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-600 bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-100"><User size={14} className="text-slate-400" /> {rem.owner}</span>
                        </div>
                      </div>
                    </div>

                    <div className="shrink-0 flex items-center justify-end w-full md:w-auto mt-2 md:mt-0 pt-4 md:pt-0 border-t md:border-t-0 border-slate-100">
                      <span className={`text-[10px] font-bold uppercase tracking-widest px-4 py-2 rounded-full ring-1 ${rem.status === 'Completed' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200' : 'bg-amber-50 text-amber-700 ring-amber-200'}`}>
                         {rem.status}
                      </span>
                    </div>

                  </div>
                </div>
              ))}
            </div>
        </div>
    </>);
};

export default RemediationTab;